/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [post-comment.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 12.10.18 13:17
 */

import React, {useEffect, useState} from 'react';
import {PENDING_STATUS, SUCCESS_STATUS} from '../../actions/index';
import EmojiEditor from '../emoji-editor/emoji-editor';
import CommentText from './comment-text';
import {getUserAvatar} from "../../actions/environment";
import {useAuthorization, useToggleComments} from "../../selectors";
import {useLanguage} from "../configuration/configuration";
import CommentNavigation from "./comment-navigation";
import useAsyncFetchComments from "../hooks/async-fetch-comments";
import {Spinner} from "../util/spinner";

const MAX_COMMENT_COUNT = 16;

const PostComments = ({username, post: {id: postId, commentCount = 0}}) => {
    const [showComments, setShowComments] = useState(false);
    const {fetchComments, createComment, comments, count, status} = useAsyncFetchComments(postId, commentCount);
    const {isAuthorized, principalUsername} = useAuthorization();
    const {action, toggle, postId: targetId} = useToggleComments();
    const Lang = useLanguage();


    useEffect(() => {
        if(targetId === postId) {
            !showComments && fetchComments(username, postId)
            setShowComments(!showComments);
        }

    }, [action, toggle, targetId])

    const renderAvatar = (avatar, fullname) => {
        return <div className="avatar-tooltip">
            <span title={fullname}><img src={avatar}/></span>
        </div>
    }

    const renderCommentEntries = () => {
        if (!comments || comments.length === 0) return <div className='mt-1 mb-2'>{Lang.post.comments.noneYet}</div>;

        return comments.map((comment) => {
            const avatar = getUserAvatar(comment.user);

            return <li key={comment.id} className='comment-item'>
                <CommentNavigation comment={comment}
                                   html={renderAvatar(avatar, comment.user.fullname)} postId={postId}/>
                <div className='comment-item-body'>
                    <CommentText comment={comment}/>
                </div>
            </li>
        });
    }

    const handleEditableBoxEnter = (comment) => {
        createComment(principalUsername, comment);
    }

    if (status === PENDING_STATUS) return <Spinner/>
    if(targetId !== null && targetId !== postId) return null;

    return <div className='post-comment'>
        {showComments && status === SUCCESS_STATUS &&
            <div className='list-group'>
                {renderCommentEntries()}

                {isAuthorized && (count < MAX_COMMENT_COUNT) && <EmojiEditor
                    navigation={false} id={postId}
                    placeholder={Lang.placeholder.comment}
                    callback={handleEditableBoxEnter}/>}
            </div>}
    </div>
}

export default PostComments;